<template>
    <li
        class="option"
        :class="{disabled: disabled, selected: selected}"
        @click.stop="handleClick"
        :key="currentOption.id"
    >
        <img :src="iconUrl">
        {{ currentOption.label }}
    </li>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { ESelectorType, IReoSelectOption } from '@reolink-cloud/interface';
import { productsManager } from '@/lib';
import OtherAnimalIcon from 'IMAGE/dashboard/animalIcons/animal_other.svg';

export default Vue.extend({
    name: 'TreeOptionMobile',
    components: {
    },
    props: {
        selectorType: {
            type: String as PropType<ESelectorType>,
            default: 'single',
        },
        dataSource: {
            type: Array as PropType<IReoSelectOption[]>,
            required: true,
        },
        currentOption: {
            type: Object as PropType<IReoSelectOption>,
            required: true
        },
        propSelection: {
            type: Array as PropType<Array<string | number>>,
            default: () => [],
        },
        widthIn: {
            type: [String, Number],
            default: -1
        },
        heightIn: {
            type: [String, Number],
            default: 0.3
        },
        fontSizeIn: {
            type: [String, Number],
            default: 0.16
        },
        reachMaxSelect: Boolean,
        allOptionDisableOthers: {
            type: Boolean,
            default: false
        }
    },
    data() {

        return {
            /** 初始化子选项的显示状态 */
            showSubList: true,

            selected: this.currentOption.selected ?? false,

        };

    },
    computed: {
        isSingleSelector(): boolean {

            return this.selectorType === ESelectorType.SINGLE;

        },
        disabled(): boolean {

            if ( this.allOptionDisableOthers ) {

                const allOption = this.dataSource.find( _option => _option.value === 'all' );
                return this.currentOption.value !== 'all' && ( allOption?.selected ?? false );

            }
            return !this.selected && this.reachMaxSelect && this.currentOption.value !== 'all';

        },
        isMobile(): boolean {

            return this.$store.getters.isMobile;

        },
        iconUrl(): string {

            const url = productsManager.getAlarmTypeInfoByKey( this.currentOption.value as string )?.meta?.iconUrl ?? '';
            if ( url && url !== '' ) {

                return url;

            } else {

                return OtherAnimalIcon;

            }

        }

    },
    watch: {
        'currentOption.selected'( newVal: boolean ) {

            this.selected = newVal;

        },
    },
    methods: {

        handleClick() {

            if ( this.isSingleSelector ) {

                this.selected = true;
                this.$emit( 'select', true, this.currentOption );

            } else {

                this.selected = !this.selected;
                this.$emit( 'select', this.selected, this.currentOption );

            }

        },

        handleChildClick( selected: boolean, childOption: IReoSelectOption ) {

            this.$emit( 'select', selected, childOption );

        }
    }
});
</script>
<style lang="less" scoped>
.option.child-option{
    padding: 6px 8px;
    width: fit-content;
    background-color: @bg_02;
    border-radius: 4px;
    font-size: 15px;
    line-height: 20px;
    display: flex;
    gap: 4px;
    // flex: 0 1;
    &.selected{
        background-color: @brand_light;
        color: @font_primary;
    }
    img{
        width: 20px;
        height: 20px;
    }
}

</style>
